import { defineMessages } from 'react-intl'

export default defineMessages({
  successTitle: {
    id: 'purchasing.assignUsersToDepartment.presenter.successTitle',
    defaultMessage: 'Success',
  },
  successMessage: {
    id: 'purchasing.assignUsersToDepartment.presenter.successMessage',
    defaultMessage: 'Permissions have been updated.',
  },
  errorTitle: {
    id: 'purchasing.assignUsersToDepartment.presenter.errorTitle',
    defaultMessage: 'Error',
  },
  errorMessage: {
    id: 'purchasing.assignUsersToDepartment.presenter.errorMessage',
    defaultMessage: 'Something went wrong. Please try again.',
  },
})
